import {Image} from 'app/blocks/model/image.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IImage} from 'app/blocks/model/image.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {Observable} from 'rxjs';
import {ImageVariant} from 'app/blocks/enum/image.variant.enum';
import {SERVER_API_URL} from 'app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class ImageService extends EntityCrudService<IImage> {
    constructor(http: HttpClient) {
        super(http, Resource.IMAGES, (obj?) => new Image(obj));
    }

    async downloadB64Image(imageId: number) {
        const data: Blob = await this.http.get(`${this._resourceUrl}/${imageId}/download`, {responseType: 'blob'}).toPromise();
        const reader = new FileReader();
        const b64 = new Promise<string>((resolve, reject) => {
            reader.addEventListener(
                'load',
                () => {
                    resolve(reader.result.toString());
                },
                false
            );
            reader.addEventListener(
                'error',
                () => {
                    reject('Error reading the file');
                },
                false
            );
            if (data) {
                reader.readAsDataURL(data);
            }
        });
        return await b64;
    }

    getImageDeliveryUrl(imageId: number, variant: ImageVariant): Observable<string> {
        return this.http.get<string>(`${this._resourceUrl}/${imageId}/delivery-url/${variant}`);
    }

    uploadImage = (folder: string, name: string, file: File, sequence: number | undefined, attributes: any[]): Promise<Image> => {
        const fd = new FormData();
        fd.append('file', file, file.name);
        fd.append('name', name);
        fd.append('folder', folder);
        if (sequence != null) {
            fd.append('sequence', sequence.toString());
        }
        if (attributes && attributes.length > 0) {
            fd.append('attributes', JSON.stringify(attributes));
        }
        return this.http.post<Image>(`${SERVER_API_URL}api/images/upload`, fd).toPromise();
    };
}
